import Components from "slotworks/components/components";
import Sequence from "slotworks/utils/contracts/sequence";
import Contract from "slotworks/utils/contracts/contract";
import sgScatterParticles from "./matrix/scatter/sg-scatter-particles";
import Layers from "slotworks/graphics/layers/layers";
import Rectangle from "slotworks/utils/geom/rectangle";
import {getOffsetRectangle} from "slotworks/utils/position-offset-calculator";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import {symbolsName, SGLayers} from "sg-consts";
import gameState from "slotworks/model/game-state";
import {Services} from "slotworks/services/services";
import {ExpansionResult} from "slotworks/model/gameplay/records/results/expansion-result";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import Record from "slotworks/model/gameplay/records/record";
import RespinRecord from "model/respin-record";
import sgBackgroundParticles from "./background/sg-background-particles";

class SGSandAnimation {
    private sandAnimation: PIXI.spine.Spine;


    private static SANDSTORM_ANIM: string = "sand_animation";

    private static SANDSTORM_IN: string = "sandstorm-intro";
    private static SANDSTORM_LOOP: string = "sandstorm-loop";
    private static SANDSTORM_OUT: string = "sandstorm-out";

    public init(): void {
        this.sandAnimation = Layers.SymbolAnimations.getSpine(SGSandAnimation.SANDSTORM_ANIM);
    }

    public playSandAnimation(): Contract<void> {
        this.sandAnimation.visible = true;
        this.sandAnimation.state.clearListeners();
        this.sandAnimation.state.setAnimation(0, SGSandAnimation.SANDSTORM_IN, false);

        sgBackgroundParticles.startSandStorm().execute();

        return new Contract<void>((resolve) => {
            this.sandAnimation.state.addListener({
                complete: () => {
                    this.sandAnimation.state.clearListeners();
                    this.sandAnimation.state.setAnimation(0, SGSandAnimation.SANDSTORM_LOOP, true);
                    resolve();
                }
            });
        });
    }

    public stopSandAnimation(): void {
        sgBackgroundParticles.stopSandStorm().execute();;

        this.sandAnimation.state.clearListeners();
        this.sandAnimation.state.setAnimation(0, SGSandAnimation.SANDSTORM_OUT, false);
        this.sandAnimation.state.addListener({
            complete: () => {
                this.sandAnimation.state.clearListeners();
                this.sandAnimation.visible = false;
            }
        });
    }

}

export default new SGSandAnimation();
